import { Grid, useEventCallback } from '@mui/material';
import { ForeignForm } from 'shell/view-models/foreign-form';
import { memo } from 'react';
import ForeignStateList, { ForeignStateVM } from 'shell/components/shared/foreign-state-list';
import { FormikErrors, FormikTouched } from 'formik';
import { MunicipalityAnprVM } from 'shell/components/shared/municipality-list';
import MunicipalityForeignList from 'shell/components/shared/municipality-foreign-list';

interface ForeignComponentProps {
  disabledComponent?: boolean;
  values?: ForeignForm | null;
  errors?: FormikErrors<ForeignForm>;
  touched?: FormikTouched<ForeignForm>;
  onChange: (key: keyof ForeignForm, value: ForeignForm[keyof ForeignForm]) => void;
  labelState?: string;
  labelMunicipality?: string;
}

const ForeignComponent = ({
  disabledComponent,
  values,
  errors,
  onChange,
  labelState = 'Stato estero di nascita',
  labelMunicipality = 'Comune estero di nascita',
}: ForeignComponentProps): React.ReactElement => {
  const handleForeignStateListChange = useEventCallback(
    (state: ForeignStateVM | null | undefined) => {
      onChange('state', state);
    }
  );

  const handleInputKeyboardChange = useEventCallback((municipality: MunicipalityAnprVM | null) => {
    onChange('municipality', municipality);
  });

  return (
    <Grid item xs={12} container spacing={2}>
      {disabledComponent && !Boolean(values?.state) ? undefined : (
        <Grid item xs={12} md={6}>
          <ForeignStateList
            value={values?.state || null}
            onChange={handleForeignStateListChange}
            disabled={disabledComponent}
            label={labelState}
            required
            id="foreignStateBirth"
            error={
              //(touched?.state as FormikTouched<ForeignStateVM>) &&
              Boolean(errors?.state as FormikErrors<ForeignStateVM>)
            }
          />
        </Grid>
      )}
      {disabledComponent && !Boolean(values?.municipality) ? undefined : (
        <Grid item xs={12} md={6}>
          <MunicipalityForeignList
            value={values?.municipality || null}
            onChange={handleInputKeyboardChange}
            label={labelMunicipality}
            required
            id="foreignMunicipality"
            disabled={disabledComponent || !values?.state?.id}
            foreignStateIstatCode={values?.state?.id}
            error={!!(errors?.municipality as FormikErrors<MunicipalityAnprVM>)?.description}
          />
        </Grid>
      )}
    </Grid>
  );
};

ForeignComponent.displayName = 'Foreign generality component';

const Foreign = memo(ForeignComponent);

export default Foreign;
